import { message, PageHeader, Spin, Upload, Row, Col } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import axios from 'axios'
import {
  Form,
  FormItem,
  TableItem,
  ButtonItem,
} from "../../../../Components/Items";
import { UploadOutlined } from "@ant-design/icons";
import * as XLSX from 'xlsx'

class ImportarUnidades extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    archivosExcel: [],
    data: [],
    archivoError: null,
    unidadesExistentes: [],
    unidadesSat: [],
  }

  componentDidMount() {
    this.setState({ loading: true })
    axios
      .post(
        "unidades/datosParaImportar",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({
          unidadesExistentes: res.data.success === 2 ? res.data.unidadesExistentes : [],
          unidadesSat: res.data.success === 2 ? res.data.unidadesSat : [],
          loading: false,
        });
      });
  }

  atras() {
    this.props.history.goBack();
  }

  onFinishFailed(e) {
    message.error("Revisa que los datos sean correctos");
  }

  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "unidades/importarUnidades",
        { empresaId: this.props.empresaId, data: this.state.data },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se importaron " + res.data.numero + " unidades");
          this.atras();
        } else if (res.data.success === 1) {
          message.error(res.data.mensaje || "No se pueden importar las unidades");
        } else {
          message.error("Hubo un error y las unidades no se importaron");
        }
      });
  }

  async onChangeArchivo(e) {
    this.setState({ loading: true })
    if (e.file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      this.setState({ archivosExcel: [{ ...e.file, name: e.file.name, status: 'uploading', response: 'Cargando', }], arhcivo: e.file });
      this.cargarArchivoExcel(e.file)
    } else {
      message.error('El archivo debe ser un archivo de excel')
      this.setState({ loading: false })
    }
  }

  descargarArchivoErrores() {
    let wbout = XLSX.write(this.state.archivoError, { bookType: 'xlsx', type: 'binary' });
    const s2ab = (s) => {
      let buf = new ArrayBuffer(s.length);
      let view = new Uint8Array(buf);
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }
    let a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" })
    let url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = 'errores.xlsx';
    a.click();
    window.URL.revokeObjectURL(url);
  }

  cargarArchivoExcel(file) {
    let hojas = [];
    let reader = new FileReader()
    reader.readAsArrayBuffer(file)
    reader.onloadend = (e) => {
      let data = new Uint8Array(e.target.result)
      let workbook = XLSX.read(data, { type: 'array' })

      workbook.SheetNames.forEach((sheetName) => {
        let Xl_row_object = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName])
        hojas.push({
          data: Xl_row_object,
          sheetName
        })
      })
      let hoja1 = hojas[0].data
      this.archivoVerificar(hoja1).then((dataReturn) => {
        if (dataReturn.errores === 0) {
          this.setState({ archivosExcel: [{ ...file, name: file.name, status: 'success' }], data: dataReturn.objeto });
        } else {
          this.setState({ archivosExcel: [{ ...file, name: file.name, status: 'success', response: 'Con errores', }], archivoError: dataReturn.archivoErrores, data: dataReturn.objeto });
          message.error('Se han detectado ' + dataReturn.errores + ' errores')
          message.info('Se se importan solo se importaran los campos correctos: ' + Number(hoja1.length - dataReturn.filaErrores))
        }
        this.setState({ loading: false })
      })
    }
  }

  async archivoVerificar(data) {
    let errores = 0
    let filaErrores = 0
    let mensaje = []
    const archivoEditar = XLSX.utils.book_new()
    const arrayErrores = []
    let objeto = []
    const nombresVistos = []
    await Promise.all(data.map(async (data, index) => {
      let mensajeErrores = null
      let erroresFila = 0
      let fila = data['__rowNum__'] + 1
      let agregarUnidad = {}
      let nombre = data['Nombre'] ? `${data['Nombre']}`.trim() : undefined
      let descripcion = data['Descripcion'] ? `${data['Descripcion']}`.trim() : undefined
      let unidadSat = data['Unidad SAT'] ? `${data['Unidad SAT']}`.trim() : undefined

      const queEste = (valor, nombreCampo) => {
        if (valor === '' || valor === undefined) {
          errores += 1
          erroresFila += 1
          mensaje.push(`${nombreCampo} fila: ${fila} esta vacio`)
          mensajeErrores = mensajeErrores ? mensajeErrores + `, ${nombreCampo} esta vacio` : `${nombreCampo} esta vacio`
        }
      }
      const queSeaStringValido = (valor, nombreCampo) => {
        const patron = /^[\p{L}\p{N}\p{P}\p{S}\s]*$/u
        if (valor !== '' && valor !== undefined) {
          if (!patron.test(valor)) {
            errores += 1
            erroresFila += 1
            mensaje.push(`${nombreCampo} fila: ${fila} no es un valor acceptado`)
            mensajeErrores = mensajeErrores ? mensajeErrores + `, ${nombreCampo} no es un valor acceptado` : `${nombreCampo} no es un valor acceptado`
          }
        }
      }

      queEste(nombre, 'Nombre')
      queEste(unidadSat, 'Unidad SAT')
      queSeaStringValido(nombre, 'Nombre')
      queSeaStringValido(descripcion, 'Descripcion')

      if (nombre) {
        const nombreRepetido = this.state.unidadesExistentes.find((unidadT) => unidadT.nombre === nombre)
        if (nombreRepetido || nombresVistos.includes(nombre)) {
          errores += 1
          erroresFila += 1
          mensaje.push(`Nombre fila: ${fila} ya existe`)
          mensajeErrores = mensajeErrores ? mensajeErrores + `, Nombre ya existe` : `Nombre ya existe`
        } else {
          nombresVistos.push(nombre)
        }
      }

      if (unidadSat) {
        const unidadSatBuscada = this.state.unidadesSat.find((unidadSatT) => {
          const stringBuscar = `${unidadSatT.nombre} - ${unidadSatT.c_ClaveUnidad}`.trim().toLowerCase()
          return stringBuscar === unidadSat.toLowerCase() || `${unidadSatT.c_ClaveUnidad}`.trim().toLowerCase() === unidadSat.toLowerCase()
        })
        if (!unidadSatBuscada) {
          errores += 1
          erroresFila += 1
          mensaje.push(`Unidad SAT fila: ${fila} no es un valor aceptado`)
          mensajeErrores = mensajeErrores ? mensajeErrores + `, Unidad SAT no es un valor de la hoja Unidades SAT` : `Unidad SAT no es un valor de la hoja Unidades SAT`
        } else {
          agregarUnidad.unidadSatId = unidadSatBuscada._id
          agregarUnidad.unidadSat = `${unidadSatBuscada.nombre} - ${unidadSatBuscada.c_ClaveUnidad}`
        }
      }

      if (erroresFila === 0) {
        objeto.push({
          nombre: nombre,
          descripcion: descripcion,
          ...agregarUnidad,
        })
      } else {
        arrayErrores.push({
          'Errores': mensajeErrores,
          'Fila archivo inicial': fila,
          ...data,
        })
        filaErrores += 1
      }
      return null
    }))
    const hoja = XLSX.utils.json_to_sheet(arrayErrores)
    XLSX.utils.book_append_sheet(archivoEditar, hoja, 'Hoja Errores')
    return { objeto: objeto, errores: errores, filaErrores, mensaje: mensaje, archivoErrores: archivoEditar }
  }

  async descargarPlantillaImportar() {
    const response = await fetch('/plantillaUnidadesInsumo.xlsx');
    const data = await response.arrayBuffer();

    let plantillaXlsx = XLSX.read(data, { type: "array" });

    const hojaUnidadesSat = this.state.unidadesSat.map((unidadSat) => {
      return {
        "Unidad SAT": `${unidadSat.nombre} - ${unidadSat.c_ClaveUnidad}`,
      }
    })

    const nuevaHojaUnidadesSat = XLSX.utils.json_to_sheet(hojaUnidadesSat);
    XLSX.utils.book_append_sheet(plantillaXlsx, nuevaHojaUnidadesSat, "Unidades SAT");

    XLSX.writeFile(plantillaXlsx, "plantillaUnidadesInsumo.xlsx");
  }

  render() {
    const columns = [
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        fixed: "left",
        width: 160,
        sorter: (a, b) => (a.nombre < b.nombre ? -1 : a.nombre > b.nombre ? 1 : 0),
        buscar: "nombre",
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        width: 220,
        buscar: "descripcion",
      },
      {
        title: "Unidad SAT",
        dataIndex: "unidadSat",
        key: "unidadSat",
        width: 200,
        render: (v) => v || '-',
      },
    ];
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Importar Unidades de Insumos"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={this.state.archivoError ? <ButtonItem onClick={this.descargarArchivoErrores.bind(this)}>Descargar Errores</ButtonItem> : null}
        />
        <div className="card-background" style={{ paddingTop: 5 }}>
          <Spin spinning={this.state.loading} tip="Cargando valores, espere por favor">
            <Form
              ref={this.formRef}
              name="importarUnidades"
              layout
              bottom={
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  Importar
                </ButtonItem>
              }
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
              <Row style={{ marginTop: 20 }}>
                <Col span={12} xs={24} sm={24} lg={12} xl={12} style={{ display: 'flex', justifyContent: 'center' }}>
                  <ButtonItem onClick={() => this.descargarPlantillaImportar()} type="primary">Descargar Plantilla</ButtonItem>
                </Col>
                <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                  <FormItem name="archivo" label="Archivo">
                    <Upload
                      showUploadList={{
                        showRemoveIcon: false,
                        showPreviewIcon: false,
                      }}
                      fileList={this.state.archivosExcel}
                      customRequest={this.onChangeArchivo.bind(this)}
                      accept='.xlsx'
                    >
                      <ButtonItem icon={<UploadOutlined />}>Subir</ButtonItem>
                    </Upload>
                  </FormItem>
                </Col>
              </Row>
            </Form>
            <TableItem
              size="small"
              dataSource={this.state.data}
              columns={columns}
              scroll={{ x: 'max-content' }}
            />
          </Spin>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ImportarUnidades);
